import * as React from 'react'
import { INode } from 'shared/types/tree'
import {
  Box,
  Button,
  Table,
  TableRow,
  TableCell,
  TableBody,
} from '@mui/material'
import {
  useCreateVersionMapping,
  useGetVersionMapping,
  goToTree,
  IParsedVersionMapping,
  IVersionMappingUpdate,
  useUpdateVersionMapping,
} from '../tree/TreeActions'
import { MappingManager } from './MappingManager'
import { createIdMap, MappingFilterType, NodeIdMap } from './utility'

export function VersionMapping({
  fromTree,
  toTree,
  reviewFilters,
  reviewIndex,
}: {
  fromTree: INode
  toTree: INode
  reviewFilters?: MappingFilterType[]
  reviewIndex?: number
}) {
  const updateVersionMapping = useUpdateVersionMapping()
  const createVersionMapping = useCreateVersionMapping()
  const getVersionMapping = useGetVersionMapping()
  const [sourceIdMapping, setSourceIdMapping] = React.useState<NodeIdMap>()
  const [destinationMapping, setDestinationMapping] =
    React.useState<NodeIdMap>()
  const [mapping, setMapping] = React.useState<IParsedVersionMapping>()

  React.useEffect(() => {
    getVersionMapping({ fromTree, toTree }).then(setMapping)
  }, [fromTree, toTree])

  React.useEffect(() => {
    setSourceIdMapping(createIdMap(fromTree))
  }, [fromTree])

  React.useEffect(() => {
    setDestinationMapping(createIdMap(toTree))
  }, [toTree])

  function getMapping() {
    getVersionMapping({ fromTree, toTree }).then(setMapping)
  }

  function createMapping() {
    createVersionMapping({ fromTree, toTree }).then(getMapping)
  }

  function treeGoFunc(tree: INode) {
    return () => goToTree({ treeId: tree.tree_id, versionId: tree.version })
  }

  function updateMapping(
    updateInfo: IVersionMappingUpdate,
    skipDataUpdate?: boolean,
  ) {
    return updateVersionMapping({ fromTree, toTree }, [updateInfo]).then(
      (resp) => {
        if (skipDataUpdate) return
        setMapping(resp)
      },
    )
  }

  return (
    <Box>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell>From</TableCell>
            <TableCell>{fromTree.body?.MasterVersionName}</TableCell>
            <TableCell>
              <Button onClick={treeGoFunc(fromTree)}>{fromTree.title}</Button>
            </TableCell>
            <TableCell>{fromTree.created_at}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>To</TableCell>
            <TableCell>{toTree.body?.MasterVersionName}</TableCell>
            <TableCell>
              <Button onClick={treeGoFunc(toTree)}>{toTree.title}</Button>
            </TableCell>
            <TableCell>{toTree.created_at}</TableCell>
          </TableRow>
        </TableBody>
      </Table>
      <Button onClick={createMapping}>Create Mapping</Button>
      {mapping && (
        <Box>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell>Missing Count:</TableCell>
                <TableCell>{mapping.missing.length}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Matched Count:</TableCell>
                <TableCell>{mapping.matched.length}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
          {sourceIdMapping && destinationMapping && (
            <Box padding-top={'10px'}>
              <MappingManager
                mapping={mapping}
                sourceIdMapping={sourceIdMapping}
                destinationMapping={destinationMapping}
                destination={toTree}
                source={fromTree}
                updateMappingFunc={updateMapping}
                reviewFilters={reviewFilters}
                reviewIndex={reviewIndex}
                doUpdate={getMapping}
              />
            </Box>
          )}
        </Box>
      )}
    </Box>
  )
}
